import { createSelector } from '@reduxjs/toolkit';
import type { ERequestApiStatus } from '../../types/appState';
import { userProfileSelector } from './userProfileSelector';

export const userProfileStatusSelector = createSelector([userProfileSelector], (profile): ERequestApiStatus | null => {
  return profile?.status || null;
});
